import {
  FETCH_PLANS_FAILURE,
  FETCH_PLANS_REQUEST,
  FETCH_PLANS_SUCCESS,
  RESET_PLANS_DATA
} from "../../constants/actionTypes";

const initialState = {
  data: {
    plans: []
  },
  dataFetched: false,
  isFetching: false,
  error: false
};

export const batchReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PLANS_DATA:
      return initialState;

    case FETCH_PLANS_REQUEST:
      return {
        ...state,
        dataFetched: false,
        isFetching: true,
        error: false
      };
    case FETCH_PLANS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        dataFetched: true,
        data: action.payload
      };
    case FETCH_PLANS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default batchReducer;
